// extracted by mini-css-extract-plugin
module.exports = {"btn":"styles_btn__1z3ja"};